import React, { useState, useEffect, useRef } from 'react';

import { formatNumber, getInputValue, formatNumericValue, parseInputValue } from '../utils';

const CMSection = ({ value = 0, totalCost = 0, onChange, isEditable = true }) => {
	const [cm, setCm] = useState(value);
	const isInitialMount = useRef(true);
	const prevValueRef = useRef(null);

	useEffect(() => {
		if (prevValueRef.current === value) {
			return;
		}

		if (value !== '' && value !== null && value !== undefined) {
			setCm(formatNumericValue(value));
		} else {
			setCm(value);
		}

		prevValueRef.current = value;
		if (isInitialMount.current) {
			isInitialMount.current = false;
		}
	}, [value]);

	const notifyChange = (updatedCm) => {
		if (onChange && !isInitialMount.current) {
			onChange(formatNumericValue(updatedCm));
		}
	};

	const handleInputChange = (e) => {
		const value = e.target.value;
		const updatedCm = parseInputValue(value);
		setCm(updatedCm);
		notifyChange(updatedCm);
	};

	const displayCost = totalCost || 0;

	return (
		<div className="single-table trims-content border mt-5">
			<div className="table-heading mb-0 d-flex align-items-center justify-content-between">
				<p>CM Cost Metrics</p>
			</div>
			<div className="row align-items-center py-2 border-bottom border-top m-0">
				<div className="col-md-2 pr-0">
					<p className="regular-12 gray_dark_02 pb-1 pl-2">CM ($)</p>
				</div>
				<div className="col-md-10">
					<input
						type="number"
						step="0.01"
						value={getInputValue(cm)}
						onChange={handleInputChange}
						readOnly={!isEditable}
					/>
				</div>
			</div>
			<div className="row align-items-center m-0 total-row">
				<div className="col-md-6 col-sm-12 mb-2 mb-0">
					<p className="semibold-14 gray_dark_01">Total CM Cost</p>
				</div>
				<div className="col-md-6 col-sm-12 mb-2 mb-0">
					<p className="semibold-14 gray_dark_01 float-right">${formatNumber(displayCost)}</p>
				</div>
			</div>
		</div>
	);
};

export default CMSection;
